module.exports = __webpack_public_path__ + "static/media/dr-consulta.dd71ca2a.svg";